<template>
  <div>
    <div id="printMe2" style="height: 100% !important">
      <vx-card style="width: 60%">
        <table>
          <tr>
            <td style="padding-right: 75px">
              <img
                src="https://int.kamyonyedekparca.com/uploads/logo.png"
                style="max-height: 120px"
                alt="login"
                class="mx-auto"
              />
            </td>
            <td>
              <h5>
                DENİZLİ CANER OTOMOTİV SAN. TİC. A.Ş.
                <br />
                Sevindik Mh. 2290 Sk. No: 96 Merkezefendi DENİZLİ
                <br />
                Tel: 90 258 268 88 99 Faks: 90 258 251 29 43
                <br />
                GÖKPINAR VD / 2920601594
              </h5>
            </td>
          </tr>
        </table>
        <table>
          <tr>
            <td><h5>Sayın</h5></td>
            <td></td>
          </tr>
        </table>
      </vx-card>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    getActDetail() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        GUIDKOD: vm.ACTID
      };
      soap.createClient(url, function (err, client) {
        client.MUTABAKAT_CARI_DETAY(args, function (err, result) {
          if (result.MUTABAKAT_CARI_DETAYResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.MUTABAKAT_CARI_DETAYResult);
            if (vm.veriler.response == "Ok") {
              var list = JSON.parse(vm.veriler.jsonData);
              vm.rowData = list;
            } else {
            }
          } catch (error) {}

          //  vm.cariHareketlerListesi = vm.veriler;
        });
      });
    },
  },
  created() {
    this.ACTID = this.$route.params.ACTID;
    console.log(this.ACTID);
  },
};
</script>
